import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { OrgNode as Node } from "@/components/OrgNode";


export default function PlatformOrganogram() {
  const [groups, setGroups] = useState([]);
  const [collapsed, setCollapsed] = useState(new Set());

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/organogram"); setGroups(data.groups || []); }
      catch (e) { toast.error(formatApiError(e)); }
    })();
  }, []);

  const toggle = (id) => setCollapsed((s) => {
    const n = new Set(s);
    if (n.has(id)) n.delete(id); else n.add(id);
    return n;
  });

  return (
    <div data-testid="platform-organogram">
      <div className="mb-4">
        <h1 className="text-2xl font-semibold" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Organogram · All Business Units</h1>
        <p className="text-sm text-zinc-500">A rolled-up organisation chart across every BU, built from Microsoft-synced line-manager relationships.</p>
      </div>
      <div className="space-y-6">
        {groups.map((g) => {
          const isCollapsed = collapsed.has(g.business_unit_id || "unassigned");
          return (
            <div key={g.business_unit_id || "unassigned"} className="border border-zinc-200 bg-white rounded-sm">
              <button
                data-testid={`org-group-toggle-${g.business_unit_id || "unassigned"}`}
                onClick={() => toggle(g.business_unit_id || "unassigned")}
                className="w-full px-5 py-3 border-b border-zinc-200 text-left flex items-center justify-between hover:bg-zinc-50"
              >
                <div className="flex items-center gap-3">
                  {g.logo_url && <img src={g.logo_url} alt="" className="w-6 h-6 rounded-sm object-contain" />}
                  <div>
                    <div className="text-sm font-semibold">{g.business_unit_name}</div>
                    <div className="text-[11px] text-zinc-500">{g.user_count} people</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  {g.business_unit_id && (
                    <Link to={`/business-units/${g.business_unit_id}`} onClick={(e) => e.stopPropagation()}
                      className="text-xs text-blue-600 hover:underline">Open BU →</Link>
                  )}
                  <span className="text-zinc-400 text-lg">{isCollapsed ? "+" : "−"}</span>
                </div>
              </button>
              {!isCollapsed && (
                <div className="p-5 overflow-auto">
                  {g.roots.length === 0 ? (
                    <div className="text-sm text-zinc-400 text-center py-6">No users in this BU.</div>
                  ) : (
                    <div className="flex gap-6 items-start">
                      {g.roots.map((r) => <Node key={r.id} node={r} />)}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
        {groups.length === 0 && (
          <div className="text-sm text-zinc-500 border border-dashed border-zinc-200 rounded-sm p-10 text-center">
            No BUs yet.
          </div>
        )}
      </div>
    </div>
  );
}
